// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqMyQuotesHeaderStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import myAccountFilterSectionStyles from "@keller/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

rfqMyQuotesHeaderStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

rfqMyQuotesHeaderStyles.quoteCountText = {
    ...(myAccountFilterSectionStyles.countGridItem as TypographyPresentationProps),
};

rfqMyQuotesHeaderStyles.toggleFilterGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.toggleFilterGridItem, {
        css: css`
            button {
                ${myAccountFilterSectionStyles.toggleFilterClickable?.css}
            }
        `,
    }),
};

rfqMyQuotesHeaderStyles.toggleFilterIcon = {
    ...myAccountFilterSectionStyles.toggleFilterIcon,
};
